'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { CONTENT_PLACEHOLDER } from 'my-purchases/constants/constants'

import styles from './OrderDate.module.scss'
import fukkuStyles from 'fukku/styles/classes.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface OrderDateProps {
	readonly date: string
}

export function OrderDate({ date }: OrderDateProps) {
	const { t } = useLabels()
	const dateContent = date === 'Invalid Date' ? CONTENT_PLACEHOLDER : date

	return (
		<>
			<p className={`${fukkuStyles.srOnly}`}>
				{`${t('accessibility.myPurchases.purchaseDate.text')} ${dateContent}`}
			</p>
			<p
				aria-hidden
				data-testid='myPurchases.purchaseCard.date'
				className={`${text.bodyS} ${styles.date}`}
			>
				{dateContent}
			</p>
		</>
	)
}
